import Util from './js/util'
import axios from 'axios';
import Common from "./js/common"
import Config from '../config/config.js'
import Vue from 'vue'
import store from '@/vuex/index'
import qs from 'qs'

function Request(url = '', method = 'GET', params = {}) {
  return new Promise((res, rej) => {
    return axios({
      method: method,
      url: Common.requestUrl(url, method.toLowerCase() === 'get' ? params : ''),
      params: method.toLowerCase() === 'get' ? params : '',
      data: method.toLowerCase() === 'post' ? params : '',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        // 'Auth': Util.getSearchJson().auth || store.getters.UserInfo.Auth || ''
      },
      transformRequest: Common.transformRequest
    }).then(r => {
      // console.log('请求完的r数据r', r);
      // console.log('r请求这里', r);

      if (r.data.Status === 403) {
        // location.reload()
        // console.log('未登陆', r);

        // Util.removeItem()
        // const searchJson = Util.getSearchJson()
        // delete searchJson.code
        // delete searchJson.state
        // delete searchJson.auth
        // const redirectURL = window.location.origin + window.location.pathname + '?' + qs.stringify(searchJson) + window.location.hash
        // window.location.replace(`${store.getters.AuthConfig.get('authUrl')}/myweight?redirect=${encodeURIComponent(redirectURL)}&force=true#/authorize`)
        // return
      }
      res(r.data)
    }).catch(error => {
      Vue.$vux.toast.show({
        type: 'text',
        text: error.message
      })
      rej(error)
    })
  })
}

function UploadRequest(url, formData) {
  return new Promise((res, rej) => {
    return axios.post(Common.requestUrl(url), formData, {
      headers: {
        'Auth': Util.getSearchJson().auth || store.getters.UserInfo.Auth || '',
        'content-type': 'multipart/form-data'
      }
    }).then(r => {
      if (r.data.Status === 254 || r.data.Status === 551) {
        // console.log('未登陆', r);
        // Util.removeItem()
        // const searchJson = Util.getSearchJson()
        // delete searchJson.code
        // delete searchJson.state
        // delete searchJson.auth
        // const redirectURL = window.location.origin + window.location.pathname + '?' + qs.stringify(searchJson) + window.location.hash
        // window.location.replace(`${store.getters.AuthConfig.get('authUrl')}/myweight?redirect=${encodeURIComponent(redirectURL)}&force=true#/authorize`)
        // return
      }
      res(r.data)
    }).catch(e => {
      res({
        Status: 201,
        Result: {
          ErrorMsg: '上传失败！'
        }
      })
    })
  })
}

export {
  Request,
  UploadRequest
}



// WEBPACK FOOTER //
// ./src/common/request.js